module.exports = __webpack_public_path__ + "static/media/irishdistillers.484028c1.png";